import React, { useState } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Input, InputGroup, InputGroupAddon } from "reactstrap";
import { Formik, Form, Field } from "formik";
import SweetAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import axios from "../../containers/api";
import logoImg from '../../assets/img/login.png'; // لوگویی که آپلود کردی

const Login = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [loginAlert, setLoginAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const initialValues = { username: "", password: "" };

  const toggleShowPassword = () => setShowPassword(!showPassword);

  const login = async (values) => {
    setLoading(true);
    try {
      const postData = { Username: values.username, Password: values.password };
      const res = await axios.post("/api/v1/User/login", postData);
      if (res.status === 200 && res.data.statusCode === 200 && res.data.data) {
        localStorage.setItem("jwt", res.data.data.accessToken);
        localStorage.setItem("member", JSON.stringify(res.data.data.member));
        localStorage.setItem("loggedIn", true);
        window.location.href = "/";
      } else {
        setAlertText(res.data.errors || "خطای ورود");
        setLoginAlert(true);
      }
    } catch (error) {
      setAlertText(error.response?.data?.message || "اتصالی با سرور ایجاد نشد!");
      setLoginAlert(true);
    } finally {
      setLoading(false);
    }
  };

  const onUserLogin = (values) => {
    if (values.username && values.password && !loading) {
      login(values);
    }
  };

  return (
    <Row className="justify-content-center align-items-center vh-100 bg-light">
      <Col xs="12" sm="10" md="6" lg="5">
        <Card className="shadow-lg rounded-lg p-4">
          <CardBody className="text-center">
            {/* لوگوی بالا */}
            <img src={logoImg} alt="Logo" style={{ width: "120px", marginBottom: "20px" }} />

            <CardTitle tag="h4" className="mb-4">ورود به پنل کاربری</CardTitle>

            <Formik initialValues={initialValues} onSubmit={onUserLogin}>
              {({ errors, touched }) => (
                <Form>
                  <InputGroup className="mb-3 rounded-pill overflow-hidden shadow-sm">
                    <Field
                      name="username"
                      className="form-control border-0"
                      placeholder="نام کاربری"
                    />
                  </InputGroup>
                  {errors.username && touched.username && (
                    <div className="text-danger mb-2">{errors.username}</div>
                  )}

                  <InputGroup className="mb-4 rounded-pill overflow-hidden shadow-sm">
                    <Field
                      name="password"
                      type={showPassword ? "text" : "password"}
                      className="form-control border-0"
                      placeholder="رمز عبور"
                    />
                    <InputGroupAddon addonType="append">
                      <Button color="secondary" onClick={toggleShowPassword}>
                        {showPassword ? "🙈" : "👁️"}
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>

                  <Button
                    type="submit"
                    color="success"
                    block
                    className="mb-3 rounded-pill shadow"
                    disabled={loading}
                  >
                    {loading ? "در حال ورود..." : "ورود"}
                  </Button>
                </Form>
              )}
            </Formik>

            <div className="d-flex justify-content-around mt-4">
              <Button
                color="primary"
                className="px-6 py-2 rounded shadow-sm"
                onClick={() => history.push("/newregister")}
              >
                ثبت نام صاحب کالا
              </Button>
              <Button
                color="warning"
                className="px-6 py-2 rounded shadow-sm"
                onClick={() => history.push("/newregisterdriver")}
              >
                ثبت نام راننده
              </Button>
            </div>

            <div className="text-center mt-3">
              <Button color="link" onClick={() => alert("صفحه فراموشی رمز")}>
                رمز را فراموش کرده‌ام
              </Button>
            </div>
          </CardBody>
        </Card>
      </Col>

      <SweetAlert
        error
        show={loginAlert}
        title="خطای ورود"
        onConfirm={() => setLoginAlert(false)}
      >
        {alertText}
      </SweetAlert>
    </Row>
  );
};

export default Login;
